import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isMobileSwipeOpened: false,
  shownErrorPage: undefined, // undefined || number
};

const coreSlice = createSlice({
  name: 'core',
  initialState,
  reducers: {
    changeMobileSwipe: (state, action) => {
      state.isMobileSwipeOpened = action.payload;
    },
    showErrorPage: (state, action) => {
      state.errorStatus = action.payload?.status;
      state.apiErrorMessage = action.payload?.message;
    },
  },
});

export const { changeMobileSwipe, showErrorPage } = coreSlice.actions;

export default coreSlice.reducer;
